<ng-container *ngIf="control; else skeleton">
<dk-ctl-sablon #sablonCmp
    [isReadOnly]="isReadOnly" [labelText]="labelText" [labelMode]="labelMode" [title]="title" [code]="code"
    (handleValueChange)="handleValueChange($event)" (codeChanges)="code = $event" [warningMessage]="warningMessage"
               [validationRules]="validationRulesMap"
    (searchClick)="searchClick()"
    (clear)="clear()">
</dk-ctl-sablon>
<dx-popup *ngIf="crudPopupVisible"
    title="Dönem Arama"
    [resizeEnabled]="false"
    [hideOnOutsideClick]="false"
    [showCloseButton]="true"
    [(visible)]="crudPopupVisible"
    (onHiding)="closePopupAfter($event, sablonCmp)"
>
        <dk-ctl-teb-donem-arama
        [control]="control"
        (closePopup)="closePopupAfter($event, sablonCmp)"
        ></dk-ctl-teb-donem-arama>
</dx-popup>
</ng-container>
<ng-template #skeleton>
  <div class="skeleton-control"></div>
</ng-template>
